import { createContext, useContext } from 'react';
import { TIMELINE_DAYS } from './constants';

export type GanttContextValue = {
  timelineStart: string; // ISO date — первый день шкалы
  columnWidth: number;
  timelineDays: number;
  filter: string;
  setFilter: (v: string) => void;
};

export const GanttContext = createContext<GanttContextValue>({
  timelineStart: '',
  columnWidth: 40,
  timelineDays: TIMELINE_DAYS,
  filter: "",
  setFilter: () => {},
});

export const useGanttContext = (): GanttContextValue => useContext(GanttContext);
